<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('modal')

export default {
    name: 'PreviewGrid',
    methods: {
        previewClick(slideIndex) {
            this.modalClose()
            setTimeout(() => {
                const event = new CustomEvent('previewClick', { detail: slideIndex });
                window.dispatchEvent(event);
            }, 300);
        },
        modalClose() {
            this.setModal(false);
        },
        ...mapMutations([
            'setModal'
        ])
    }
}
</script>
